import AuxiliarCompras from '../../../../Utiles/Compra/AuxiliarCompras';
export default class AuxiliarCompra extends AuxiliarCompras {
    nuevo = true;
    ordenes = 'Copiar';
}